import { useEffect, useState } from "react";

// Chrome's install permission (beforeinstallprompt) can be used ONCE: keep a single shared copy.
let deferred = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f(deferred));

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; emit(); });
  window.addEventListener("appinstalled", () => { deferred = null; emit(); });
}

export const useInstallAvailable = () => {
  const [evt, setEvt] = useState(deferred);
  useEffect(() => { subs.add(setEvt); return () => subs.delete(setEvt); }, []);
  return !!evt;
};

// Returns "accepted" | "dismissed" | "failed" (no permission / browser refused).
export const promptInstall = async () => {
  const e = deferred;
  if (!e) return "failed";
  deferred = null;
  emit();
  try {
    await e.prompt();
    const res = await e.userChoice;
    return res?.outcome === "accepted" ? "accepted" : "dismissed";
  } catch {
    return "failed";
  }
};

export const openInstallGuide = () => window.dispatchEvent(new Event("appresse:open-install"));
